import _ from 'lodash';
import md5 from 'js-md5';
import * as types from '../mutation-types';
import api from '../../api';

const state = {
  carts: [],
  selectedIds: null,
  rakuten: [],
  yahoo_jp: [],
  amazon_jp: [],
  showCart: false,
};

/* eslint-disable camelcase, object-curly-newline */

const getters = {
  getCartCount: s => s.carts.length + s.rakuten.length + s.yahoo_jp.length + s.amazon_jp.length,
  // 商品總價getter
  getCartProductTotal: (s) => {
    const app = (_.reduce(s.carts, (total, c) => total + (c.unit_price * c.quantity), 0));
    const rakuten = (_.reduce(s.rakuten, (total, c) => total + (c.unit_price * c.quantity), 0));
    const yahoo_jp = (_.reduce(s.yahoo_jp, (total, c) => total + (c.unit_price * c.quantity), 0));
    const amazon_jp = (_.reduce(s.amazon_jp, (total, c) => total + (c.unit_price * c.quantity), 0));
    return app + rakuten + yahoo_jp + amazon_jp;
  },
  // 獲取所有購物車porudct_id
  getCartProductIds: s => _.map(s.carts, 'product_id'),
  // 獲取所有購物車id
  getCartIds: s => _.map(s.carts, 'id'),
  getRakutenCartIds: s => _.map(s.rakuten, 'id'),
  getYahooJpCartIds: s => _.map(s.yahoo_jp, 'id'),
  getAmazonJpCartIds: s => _.map(s.amazon_jp, 'id'),
};

const actions = {
  setShowCart({ commit }, val) {
    commit(types.SET_SHOWCART, val);
  },
  setCartSelectedIds({ commit }, ids) {
    commit(types.SET_CART_SELECTED_IDS, ids);
  },
  removeCart({ commit, rootGetters }, id) {
    if (!rootGetters.isLogined) {
      commit(types.REMOVE_CART_ITEM, id);
      return Promise.resolve();
    }
    return api.cart.delete(id).then((response) => {
      if (response.status === 204) {
        commit(types.REMOVE_CART_ITEM, id);
      }
    });
  },
  getCart({ commit, rootGetters }) {
    /* eslint no-else-return:0 */
    if (rootGetters.isLogined) {
      return Promise.all([
        api.cart.get(),
        api.thirdPartyShopCart.get(),
      ]).then((response) => {
        commit(types.RECEIVE_CARTS, response[0].data.data);
        const grouped = _.groupBy(response[1].data.data, 'shop_name');
        if (grouped.rakuten) {
          commit(types.REVEICE_THIRD_PARTY_SHOP_CARTS, { shop_name: 'rakuten', data: grouped.rakuten });
        }
        if (grouped.yahoo_jp) {
          commit(types.REVEICE_THIRD_PARTY_SHOP_CARTS, { shop_name: 'yahoo_jp', data: grouped.yahoo_jp });
        }
        if (grouped.amazon_jp) {
          commit(types.REVEICE_THIRD_PARTY_SHOP_CARTS, { shop_name: 'amazon_jp', data: grouped.amazon_jp });
        }
      });
    }
    return Promise.resolve();
  },
  // 保存session購物車
  saveSessionCart({ state: s, commit }) {
    _.forEach(s.carts, (item) => {
      if (~item.id.indexOf('session')) {
        const params = {
          product_id: item.product_id,
          product_specification_id: item.product_specification_id,
          quantity: item.quantity,
        };
        api.cart.post(params).then(({ data: response }) => {
          commit(types.REMOVE_CART_ITEM, item.id);
          commit(types.ADD_TO_CART, response.data);
        });
      }
    });
    // rakuten
    _.forEach(s.rakuten, (item) => {
      if (~item.id.indexOf('session')) {
        const shop_name = 'rakuten';
        const params = {
          product_id: item.product_id,
          shop_name,
          quantity: item.quantity,
        };
        api.thirdPartyShopCart.post(params).then(({ data: response }) => {
          commit(types.REMOVE_THIRD_PARTY_SHOP_CART, { shop_name, id: item.id, extra: item.extra });
          commit(types.ADD_THIRD_PARTY_SHOP_CART, response.data);
        });
      }
    });
    // yahoo jp
    _.forEach(s.yahoo_jp, (item) => {
      if (~item.id.indexOf('session')) {
        const shop_name = 'yahoo_jp';
        const params = {
          product_id: item.product_id,
          shop_name,
          quantity: item.quantity,
        };
        api.thirdPartyShopCart.post(params).then(({ data: response }) => {
          commit(types.REMOVE_THIRD_PARTY_SHOP_CART, { shop_name, id: item.id, extra: item.extra });
          commit(types.ADD_THIRD_PARTY_SHOP_CART, response.data);
        });
      }
    });
    // amazon jp
    _.forEach(s.amazon_jp, (item) => {
      if (~item.id.indexOf('session')) {
        const shop_name = 'amazon_jp';
        const params = {
          product_id: item.product_id,
          shop_name,
          quantity: item.quantity,
        };
        api.thirdPartyShopCart.post(params).then(({ data: response }) => {
          commit(types.REMOVE_THIRD_PARTY_SHOP_CART, { shop_name, id: item.id, extra: item.extra });
          commit(types.ADD_THIRD_PARTY_SHOP_CART, response.data);
        });
      }
    });
    return Promise.resolve();
  },
  updateCart({ commit, rootGetters }, { id, quantity }) {
    // 未登錄狀態
    if (!rootGetters.isLogined) {
      commit(types.UPDATE_CART, { id, quantity });
      return Promise.resolve();
    }
    // 登錄狀態
    return api.cart.put(id, quantity).then(({ data: response }) => {
      commit(types.ADD_TO_CART, response.data);
    });
  },
  addToCart({ commit, dispatch, state: s }, { product, specification, quantity = 1, isMobiles }) {
    const product_id = _.isObject(product) ? product.id : product;
    const product_specification_id = _.isObject(specification) ? specification.id : specification;
    const productStore = _.find(s.carts, { product_id, product_specification_id });
    if (productStore) {
      if (!isMobiles) {
        commit(types.SET_SHOWCART, true);
      }
      return dispatch('updateCart', { id: productStore.id, quantity: productStore.quantity + quantity });
    } else {
      const params = {
        product_id,
        product_specification_id,
        quantity,
      };
      return api.cart.post(params).then(({ data: response }) => {
        commit(types.ADD_TO_CART, response.data);
        if (!isMobiles) {
          commit(types.SET_SHOWCART, true);
        }
      });
    }
  },
  addThirdPartyShopCart(
    { commit, dispatch, state: s },
    { product_id, platform_id, shop_name, quantity = 1, extra },
  ) {
    const productStore = _.find(s[shop_name], { product_id, extra });
    if (productStore) {
      commit(types.SET_SHOWCART, true);
      return dispatch('updateThirdPartyShopCart', {
        shop_name,
        id: productStore.id,
        quantity: productStore.quantity + quantity,
        extra,
      });
    } else {
      return api.thirdPartyShopCart.post({ product_id, platform_id, quantity, extra }).then(({ data: response }) => {
        commit(types.ADD_THIRD_PARTY_SHOP_CART, response.data);
        commit(types.SET_SHOWCART, true);
      });
    }
  },
  updateThirdPartyShopCart({ commit, rootGetters }, { shop_name, id, quantity, extra }) {
    // 未登錄狀態
    if (!rootGetters.isLogined) {
      commit(types.UPDATE_THIRD_PARTY_SHOP_CART, { shop_name, id, quantity, extra });
      return Promise.resolve();
    }
    // 登錄狀態
    return api.thirdPartyShopCart.put(id, quantity).then(({ data: response }) => {
      commit(types.ADD_THIRD_PARTY_SHOP_CART, response.data);
    });
  },
  removeThridPartyShopCart({ commit, rootGetters }, { shop_name, id, extra }) {
    if (!rootGetters.isLogined) {
      commit(types.REMOVE_THIRD_PARTY_SHOP_CART, { shop_name, id, extra });
      return Promise.resolve();
    }
    return api.thirdPartyShopCart.delete(id).then((response) => {
      if (response.status === 204) {
        commit(types.REMOVE_THIRD_PARTY_SHOP_CART, { shop_name, id, extra });
      }
    });
  },
};
/* eslint no-param-reassign: 0 */
const mutations = {
  [types.EMPTY_CART](s) {
    s.carts = [];
    s.rakuten = [];
    s.yahoo_jp = [];
    s.amazon_jp = [];
  },
  [types.SET_SHOWCART](s, val) {
    s.showCart = val;
  },
  [types.REMOVE_CART_ITEM](s, id) {
    s.carts = _.reject(s.carts, item => item.id === id);
  },
  [types.RECEIVE_CARTS](s, data) {
    s.carts = [...data];
  },
  [types.REVEICE_THIRD_PARTY_SHOP_CARTS](s, { shop_name, data }) {
    s[shop_name] = [...data];
  },
  [types.ADD_TO_CART](s, data) {
    const index = _.findIndex(s.carts, {
      product_id: data.product_id,
      product_specification_id: data.product_specification_id,
    });
    if (!data.id) {
      // 沒有ID的購物車數據，自動添加臨時ID
      const hash = md5(data.product_id + data.product_specification_id);
      // eslint-disable-next-line
      data.id = 'session-' + hash.substring(0, 6);
    }
    if (!~index) {
      s.carts = [...s.carts, data];
    } else {
      // 複製數據，使其觸發getter函數
      const newCart = [...s.carts];
      newCart[index] = data;
      s.carts = newCart;
    }
  },
  [types.UPDATE_CART](s, { id, quantity }) {
    const index = _.findIndex(s.carts, { id });
    if (~index) {
      const newCart = [...s.carts];
      newCart[index].quantity = quantity;
      s.carts = newCart;
    }
  },
  [types.ADD_THIRD_PARTY_SHOP_CART](s, data) {
    if (!data.id) {
      // 沒有ID的購物車數據，自動添加臨時ID
      const hash = md5(data.product_id + data.shop_name);
      // eslint-disable-next-line
      data.id = 'session-' + hash.substring(0, 6);
    }
    let thirdPartyShopCart;
    switch (data.shop_name) {
      case 'rakuten':
        thirdPartyShopCart = s.rakuten;
        break;
      case 'yahoo_jp':
        thirdPartyShopCart = s.yahoo_jp;
        break;
      case 'amazon_jp':
        thirdPartyShopCart = s.amazon_jp;
        break;
      default:
        throw Error('沒有該商店');
    }
    const index = _.findIndex(thirdPartyShopCart, {
      product_id: data.product_id,
      extra: data.extra,
    });
    if (!~index) {
      s[data.shop_name] = [...thirdPartyShopCart, data];
    } else {
      thirdPartyShopCart[index] = data;
      s[data.shop_name] = [...thirdPartyShopCart];
    }
  },
  [types.UPDATE_THIRD_PARTY_SHOP_CART](s, { shop_name, id, quantity }) {
    let thirdPartyShopCart;
    switch (shop_name) {
      case 'rakuten':
        thirdPartyShopCart = s.rakuten;
        break;
      case 'yahoo_jp':
        thirdPartyShopCart = s.yahoo_jp;
        break;
      case 'amazon_jp':
        thirdPartyShopCart = s.amazon_jp;
        break;
      default:
        throw Error('沒有該商店');
    }
    const index = _.findIndex(thirdPartyShopCart, { id });
    if (~index) {
      thirdPartyShopCart[index].quantity = quantity;
      s[shop_name] = thirdPartyShopCart;
    }
  },
  [types.REMOVE_THIRD_PARTY_SHOP_CART](s, { shop_name, id, extra }) {
    s[shop_name] = _.reject(s[shop_name], item => item.id === id && item.extra === extra);
  },
  [types.SET_CART_SELECTED_IDS](s, ids) {
    s.selectedIds = ids;
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
